<script setup>
import { computed } from 'vue'

const props = defineProps({
  goldPlanPrice: { type: Number, required: true },
  goldPlanOffered: { type: Boolean, default: true },
})

/**
 * Ten students, at the price the slider is on.
 *
 * There were three columns here, one per plan, and the total added all three —
 * which promised a tutor thirty students and income from two products nobody
 * could buy.
 */
const STUDENTS_ASSUMED = 10

const totalRevenue = computed(() =>
  props.goldPlanOffered ? Math.round(props.goldPlanPrice * STUDENTS_ASSUMED) : 0
)
</script>

<template>
  <section id="pricing-summary" class="mb-8">
    <div class="rounded-2xl border border-line bg-surface p-5 md:p-8">
      <h3 class="mb-6 text-xl font-bold text-ink">Pricing Summary &amp; Revenue Projection</h3>
      <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
        <div :class="[
          'rounded-xl p-6 transition-all',
          goldPlanOffered ? 'bg-brand-soft' : 'bg-surface-2 opacity-50'
        ]">
          <div class="mb-2 flex items-center justify-between">
            <span :class="['text-sm font-medium', goldPlanOffered ? 'text-muted' : 'text-subtle']">1:1 Tutoring</span>
            <span :class="['material-symbols-outlined', goldPlanOffered ? 'text-brand' : 'text-subtle']">workspace_premium</span>
          </div>
          <p :class="['text-3xl font-bold', goldPlanOffered ? 'text-ink' : 'text-subtle']">
            £{{ goldPlanOffered ? goldPlanPrice : 0 }}
          </p>
          <p :class="['text-xs mt-1', goldPlanOffered ? 'text-muted' : 'text-subtle']">
            {{ goldPlanOffered ? 'weekly subscription' : 'not offered' }}
          </p>
        </div>

        <div class="rounded-xl bg-success-bg p-6">
          <div class="mb-2 flex items-center justify-between">
            <span class="text-sm font-medium text-muted">Est. Weekly</span>
            <span class="material-symbols-outlined text-success">trending_up</span>
          </div>
          <p class="text-3xl font-bold text-ink">£{{ totalRevenue }}</p>
          <p class="mt-1 text-xs text-muted">with {{ STUDENTS_ASSUMED }} students</p>
        </div>
      </div>
    </div>
  </section>
</template>
